import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';

export default function VeteranClaimModal({ isAuthenticated, user }) {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    const readLink = () => {
      const match = window.location.hash.match(/^#veteran-claim=([A-Za-z0-9_-]{40,100})$/);
      if (match) {
        setToken(match[1]);
        // Keep approval tokens out of subsequent URLs, referrers and history.
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };
    readLink();
    window.addEventListener('hashchange', readLink);
    return () => window.removeEventListener('hashchange', readLink);
  }, []);
  const connect = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      const result = await axios.post('/veteran-verifications/claim', { token });
      setMessage(result.data.message);
    } catch (e) { setError(e.response?.data?.detail || 'Could not connect veteran pricing. Please try again.'); }
    finally { setBusy(false); }
  };
  return <Dialog open={!!token} onOpenChange={open => { if (!open) setToken(''); }}>
    <DialogContent overlayClassName="z-[10020]" className="z-[10021] w-[calc(100%-2rem)] max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-2xl bg-[#FFFCF7] text-[#021426]">
      <DialogHeader><DialogTitle>Connect your veteran pricing</DialogTitle>
        <DialogDescription>{message || (isAuthenticated ? `Connect your approved request to ${user?.email || 'your signed-in account'}.` : 'Sign in or create an account, then reopen the approval link from your email to connect your veteran pricing.')}</DialogDescription>
      </DialogHeader>
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {message ? <Button onClick={() => setToken('')}>Close</Button> : isAuthenticated ? <Button disabled={busy} onClick={connect} className="bg-[#FEAB3D] text-[#021426] min-h-11">{busy ? 'Connecting…' : 'Connect to this account'}</Button> : <Button onClick={() => navigate('/auth')}>Sign in / Create account</Button>}
    </DialogContent>
  </Dialog>;
}
